export const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:8888';

/** Auth header helper */
export function authHdr(): Record<string, string> {
  const token = localStorage.getItem('token')
  return token ? { Authorization: `Bearer ${token}` } : {}
}

/**
 * apiFetch — Rust backend'e istek at.
 * Her zaman raw Response döner — caller .json() ile parse eder.
 */
export async function apiFetch(url: string, options: RequestInit = {}): Promise<Response> {
  const token = localStorage.getItem('token')
  const isFormData = options.body instanceof FormData

  // FormData durumunda browser Content-Type ve boundary'yi kendisi eklemeli.
  // Sadece Authorization header'ı gönderiyoruz.
  if (isFormData) {
    const headers: Record<string, string> = {}
    if (token) headers['Authorization'] = `Bearer ${token}`
    
    return fetch(url, {
      ...options,
      headers
    })
  }

  // Normal JSON veya diğer istekler
  const headers: Record<string, string> = {
    ...(options.headers as Record<string, string> || {}),
  }
  
  if (token) {
    headers['Authorization'] = `Bearer ${token}`
  }

  if (options.body && typeof options.body === 'string') {
    headers['Content-Type'] = headers['Content-Type'] || 'application/json'
  }

  return fetch(url, {
    ...options,
    headers
  })
}

/**
 * apiFetchJSON — apiFetch + otomatik JSON parse.
 */
export async function apiFetchJSON<T>(url: string, options: RequestInit = {}): Promise<T> {
  const res = await apiFetch(url, options)
  return res.json() as Promise<T>
}
